<div (click)="navToHome()">
  <img [src]="logo | safeImage" class="app-logo" />
</div>
